<div class="mt-1 px-1" [ngClass]="templateClass">
  <small>
    {{ templateName }}
  </small>
</div>
